import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Spin } from 'antd';
import { GetCredentials, UpdateUserData } from 'Api';

const UserDetailsPage = ({ userData, refreshUsers, close }) => {
  const [form] = Form.useForm();
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSave = async () => {
    setLoading(true)
    const name = form.getFieldValue("name");
    const balance = form.getFieldValue("balance") * 1;
    await UpdateUserData({name, balance}, userData?.uid);
    setLoading(false)
    refreshUsers();
    close();
  };

  useEffect(() => {
    getcred();
    form.setFieldValue("name", userData?.name)
    form.setFieldValue("balance", userData?.balance)
    setLoading(false)
  }, [userData])
  

  async function getcred(){
    const res = await GetCredentials(userData?.uid);
    form.setFieldValue("email", res?.email)
    form.setFieldValue("password", res?.password)
  }

  return (
    <Spin spinning={loading}>
      <Form form={form} layout="vertical">
        <Form.Item label="Name" name="name" initialValue={userData.name} rules={[{ required: true, message: 'Please enter a name' }]}>
          <Input disabled={!isEditing} />
        </Form.Item>
        <Form.Item label="Balance" name="balance" initialValue={userData.balance} rules={[{ required: true, message: 'Please enter balance' }]}>
          <Input prefix="$" type="number" disabled={!isEditing} />
        </Form.Item>
        <Form.Item label="Email" name="email" >
          <Input readOnly />
        </Form.Item>
        <Form.Item label="Password" name="password">
          <Input.Password readOnly />
        </Form.Item>
      </Form>
      {isEditing ? (
        <Button type="primary" onClick={handleSave}>
          Save
        </Button>
      ) : (
        <Button type="primary" onClick={handleEdit}>
          Edit
        </Button>
      )}
    </Spin>
  );
};

export default UserDetailsPage;
